<script>
  import LoadingSpinner from "../UI/LoadingSpinner.svelte";

  export let bereich = "";
  export let standnr = "";

  let isLoading = true;
  let signalFarbe = "#ffd120";

  const raumplansvg = fetch("img/raumplan_2019_final_ausbildungsliste.svg")
    .then(r => {
      if (!r.ok) {
        throw new Error("Kein Raumplan gefunden. Bitte nocheinmal versuchen.");
      } else {
        return r.text();
      }
    })
    .then(svg => {
      isLoading = false;
      document.getElementById("rp").innerHTML = svg;
      //     console.log(svg);
      initPlan();
    })
    .catch(error => {
      isLoading = false;
      console.log(error);
    });

  function initPlan() {
    switch (bereich) {
      case "Erdgeschoss":
        console.log(bereich);
        document.getElementById("RPOG").setAttribute("display", "none");
        document.getElementById("RPEG").setAttribute("display", "show");
        document.getElementById("RPUG").setAttribute("display", "none");
        break;
      case "Obergeschoss":
        console.log(bereich);
        document.getElementById("RPOG").setAttribute("display", "show");
        document.getElementById("RPEG").setAttribute("display", "none");
        document.getElementById("RPUG").setAttribute("display", "none");
        break;
      case "Tiefgarage":
        console.log(bereich);
        document.getElementById("RPOG").setAttribute("display", "none");
        document.getElementById("RPEG").setAttribute("display", "none");
        document.getElementById("RPUG").setAttribute("display", "show");
        break;
      case "Außenbereich":
        console.log(bereich);
        document.getElementById("RPOG").setAttribute("display", "none");
        document.getElementById("RPEG").setAttribute("display", "show");
        document.getElementById("RPUG").setAttribute("display", "none");
        break;
      default:
        console.log("default. " + bereich);
    }

    document.getElementById("T" + standnr).setAttribute("display", "show");
    document.getElementById("SU" + standnr).setAttribute("fill", signalFarbe);
  }
</script>

<style>
  :global(text, tspan) {
    font-family: "Segoe UI", Frutiger, "Frutiger Linotype", "Dejavu Sans",
      "Helvetica Neue", Arial, sans-serif;
  }

  /* Extrawürste */
  :global(#SU55, #SU56, #NU55, #NU56, #SU58, #NU58) {
    display: none;
  }
</style>

{#if isLoading}
  <LoadingSpinner />
{/if}
<div id="rp" />
